import { useEffect } from 'react';
import Email from '../../images/email.svg';
import Instagram from '../../images/instagram.svg';
import TikTok from '../../images/tiktok.svg';
import YouTube from '../../images/youtube.svg';
import './contact.scss';
import { applySeo } from '../../utils/seo';
import { siteUrl } from '../../utils/seo';

const Contact = () => {
    const isMobileDevice = typeof navigator !== 'undefined'
        && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const instagramHref = isMobileDevice
        ? 'https://www.instagram.com/_u/astro_davido/'
        : 'https://www.instagram.com/astro_davido/';
    const socialTarget = isMobileDevice ? undefined : '_blank';
    const socialRel = isMobileDevice ? undefined : 'noreferrer';

    useEffect(() => {
        applySeo({
            title: 'Contact David Joyce | AstroDavido Astrophotography',
            description: 'Get in touch with David Joyce about astrophotography, image features, collaborations, or general questions.',
            canonicalPath: '/contact/',
            ogImage: `${siteUrl}/logo192.png`
        });
    }, []);

    return (
        <div className='contact-page'>
            <section className='contact-hero'>
                <h1>Contact</h1>
                <p>
                    If you&apos;d like to reach out about astrophotography, image features, collaborations,
                    publications, or just say hello, email is the best place to start.
                </p>
            </section>

            <section className='contact-card'>
                <div className='contact-methods'>
                    <a className='contact-method' href='mailto:astro.davido84@gmail.com'>
                        <div className='contact-method-icon'>
                            <img src={Email} alt='Email icon' />
                        </div>
                        <div className='contact-method-copy'>
                            <p className='contact-method-label'>Email</p>
                            <h2>astro.davido84@gmail.com</h2>
                            <p>Best for questions, collaborations, publication inquiries, and general contact.</p>
                        </div>
                    </a>

                    <a
                        className='contact-method'
                        href={instagramHref}
                        target={socialTarget}
                        rel={socialRel}
                    >
                        <div className='contact-method-icon'>
                            <img src={Instagram} alt='Instagram icon' />
                        </div>
                        <div className='contact-method-copy'>
                            <p className='contact-method-label'>Instagram</p>
                            <h2>@astro_davido</h2>
                            <p>Great for a quick message or following along with what I&apos;m currently imaging.</p>
                        </div>
                    </a>

                    <a
                        className='contact-method'
                        href='https://www.tiktok.com/@astro_davido'
                        target={socialTarget}
                        rel={socialRel}
                    >
                        <div className='contact-method-icon'>
                            <img src={TikTok} alt='TikTok icon' />
                        </div>
                        <div className='contact-method-copy'>
                            <p className='contact-method-label'>TikTok</p>
                            <h2>@astro_davido</h2>
                            <p>Short-form clips, astrophotography updates, and another easy way to keep up with my work.</p>
                        </div>
                    </a>

                    <a
                        className='contact-method'
                        href='https://www.youtube.com/@astro_davido'
                        target={socialTarget}
                        rel={socialRel}
                    >
                        <div className='contact-method-icon'>
                            <img src={YouTube} alt='YouTube icon' />
                        </div>
                        <div className='contact-method-copy'>
                            <p className='contact-method-label'>YouTube</p>
                            <h2>@astro_davido</h2>
                            <p>Short videos on my astrophotography and astronomy, and another way to follow along with my work.</p>
                        </div>
                    </a>
                </div>

            </section>
        </div>
    );
};

export default Contact;
